import React from "react";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  AllFabricATSInquiryCriteriaBean,
  CustomerFabricStyleATSInfoDetailsPrintRequest,
  CustomerOnOrderWithAtsInfoBean,
  FabricStyleBean,
  FabricStyleInventoryDataBean,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
  RestSkuBatchInventoryListRequest,
  SkuBatchInventorySummaryDetailsPrintRequest,
} from "../ds/ds.js";
import {
  AlertToolBox,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
  ColumnDefinition,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupFabricStyleModule,
  PopupPurchaseOrderModule,
  PopupPurchaseReceiptModule,
  PopupSalesModule,
  PopupVendorModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class CustomerFabricsATS extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.fabricCodeRef = React.createRef();
    this.itemlistCodeRef = React.createRef();
    this.state = {
      pageTitle: "Customer Fabric ATS-Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      criteria: new AllFabricATSInquiryCriteriaBean(),
      inventoryDataBean: new FabricStyleInventoryDataBean(),
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMessage: [],
      alertType: "",
      alertMsg: "",
      success_list: [],
      isShowFabricStyleModule: false,
      isShowCustomerModule: false,
      isShowVendorModule: false,
      isShowPurchaseOrderModule: false,
      isShowSalesModule: false,
      isShowPurchaseReceiptModule: false,
      moduleForPopup: [],
      isShowOnHandQtyPopup: false,
      isShowOnHandQtySummaryPopup: false,
      isShowVendorQtyPopup: false,
      colorLookupHandler: null,
      isShowColorLookup: false,
      colorList: [],
      fabricStyleData: new FabricStyleBean(),
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      showAutoCompleteFabricColorList: true,
      vendorList: [],
      vendorDataList: new CustomerOnOrderWithAtsInfoBean(),
      onHandQtyDataList: [],
      onHandQtySummaryDataList: [],
      vendorQtyDataList: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isFabricLookup: true,
      isDisableFields: false,
      is3PL: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  readFabricStyleResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      criteria.fabricStylesCode = fabricStyle.code;
      this.setState({ fabricStyleData: fabricStyle });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readFabricStyle = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readFabricStyleResponse,
      this.errorCallBack
    );
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        criteria: criteria,
        fabricPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
          });
        }
      }
    }
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.readandsetFabricStyleDetail(fabricStyleCode);
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteFabricList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteFabricList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleColorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == searchString
        )
          skuBean = sku;
      });
    }
    criteria.fabricStyleColorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(fabricStyleColourCode);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == colorCode
        )
          skuBean = sku;
      });
    }
    criteria.fabricStyleColorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  loadPage = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing",
    });
    this.loadCustomerFabricAtsInquiryList(criteria);
  };
  loadCustomerFabricAtsInquiryList = (listRequest) => {
    if (SecurityAccessManager.CustomerFabricATSInquiry_IsAccessible()) {
      ReportService.inquireCustomerFabricStyleATSInfo(
        listRequest,
        this.loadCustomerFabricAtsPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadCustomerFabricAtsPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.inquiryResult != null) {
      let resultList = new Array();
      if (!isEmptyArray(response.data.inquiryResult.info)) {
        resultList = response.data.inquiryResult.info;
        this.setState({
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        inquiryDataList: resultList,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        isFabricLookup: false,
        isShowColorLookup: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : " + error);
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearCriteria = () => {
    let criteria = new AllFabricATSInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    criteria.fabricStyleCode = "";
    this.setState({
      criteria: criteria,
      isShowColorLookup: false,
    });
  };
  resetInquiry = () => {
    let criteria = new AllFabricATSInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowExcelButton: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isShowColorLookup: false,
      fabricStyleData: [],
      isFabricLookup: true,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  generateExcel = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new CustomerFabricStyleATSInfoDetailsPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.CustomerFabricATSInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateCustomerFabricStyleATSInfoDetailsPrintReport(
          listRequest,
          this.generateCustomerFabricATSPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateCustomerFabricATSPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onHandQuantityClick = (e, val, rowData) => {
    if (e.detail === 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Fetching OnHandQty ...",
      });
      let inventoryDataBean = this.state.inventoryDataBean;
      inventoryDataBean.companyCode = this.companyCode;
      inventoryDataBean.fabricStyleCode = rowData.fabricStyleCode;
      inventoryDataBean.fabricStyleName = rowData.fabricStyleName;
      inventoryDataBean.fabricStyleColorCode = rowData.fabricStyleColorCode;
      inventoryDataBean.totalOnHandQuantity = rowData.onHandQuantity;
      inventoryDataBean.uomCode = rowData.uomCode;
      this.setState({ inventoryDataBean: inventoryDataBean });
      let qtyCriteria = new CustomerOnOrderWithAtsInfoBean();
      qtyCriteria.companyCode = this.companyCode;
      qtyCriteria.fabricStyleCode = rowData.fabricStyleCode;
      qtyCriteria.colorCode = rowData.fabricStyleColorCode;
      qtyCriteria.fetchQuantityAvailableLinesOnly = true;
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestSkuBatchInventoryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = qtyCriteria;
      if (rowData.onHandQuantity > 0) {
        this.loadOnHandQtyListPage(listRequest);
      } else {
        let errMsg = "No data found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  loadOnHandQtyListPage = (listRequest) => {
    InventoryService.getSkuBatchInventoryPageList(
      listRequest,
      this.loadOnHandQtyPageResponse,
      this.errorCallBack
    );
  };
  loadOnHandQtyPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.skuBatchInventoryPageList != null
    ) {
      let onHandQtyList = new Array();
      if (
        !isEmptyArray(
          response.data.skuBatchInventoryPageList.skuBatchInventories
        )
      ) {
        onHandQtyList =
          response.data.skuBatchInventoryPageList.skuBatchInventories;
      }
      this.setState({
        onHandQtyDataList: onHandQtyList,
        isShowOnHandQtyPopup: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateOnHandQtyPdf = (e) => {
    if (e.detail === 1) this.generateOnHandQtyReport(1);
  };
  generateOnHandQtyExcel = (e) => {
    if (e.detail === 1) this.generateOnHandQtyReport(2);
  };
  generateOnHandQtyReport = (reportType) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report ...",
    });
    let inventoryDataBean = this.state.inventoryDataBean;
    let criteria = new CustomerOnOrderWithAtsInfoBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = inventoryDataBean.fabricStyleCode;
    criteria.colorCode = inventoryDataBean.fabricStyleColorCode;
    criteria.fetchQuantityAvailableLinesOnly = true;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new RestSkuBatchInventoryListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.reportBean = reportBean;
    listRequest.pageInput = pageInput;
    ReportService.downloadPopUpItemOnOrderPrintReport(
      listRequest,
      this.generateOnHandQtyResponse,
      this.errorCallBack
    );
  };
  generateOnHandQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onHandQtySummaryOnClick = (e) => {
    if (e.detail === 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Fetching Onhand Sumary ...",
      });
      let inventoryDataBean = this.state.inventoryDataBean;
      let criteria = new CustomerOnOrderWithAtsInfoBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = inventoryDataBean.fabricStyleCode;
      criteria.colorCode = inventoryDataBean.fabricStyleColorCode;
      criteria.fetchQuantityAvailableLinesOnly = true;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      let listRequest = new RestSkuBatchInventoryListRequest();
      listRequest.searchCriteria = criteria;
      listRequest.pageInput = pageInput;
      InventoryService.getSKUBatchInventoriesSummary(
        criteria,
        this.loadOnHandQtySummaryResponse,
        this.errorCallBack
      );
    }
  };
  loadOnHandQtySummaryResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.skuBatchSummaryResult != null) {
      let onHandQtySummaryDataList = new Array();
      if (
        !isEmptyArray(response.data.skuBatchSummaryResult.inventorySummaryBean)
      ) {
        onHandQtySummaryDataList =
          response.data.skuBatchSummaryResult.inventorySummaryBean;
      }
      this.setState({
        onHandQtySummaryDataList: onHandQtySummaryDataList,
        isShowOnHandQtySummaryPopup: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateOnHandQtySummaryPdf = (e) => {
    if (e.detail === 1) this.generateOnHandQtySummaryReport(1);
  };
  generateOnHandQtySummaryExcel = (e) => {
    if (e.detail === 1) this.generateOnHandQtySummaryReport(2);
  };
  generateOnHandQtySummaryReport = (reportType) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Genertaing Report ...",
    });
    let inventoryDataBean = this.state.inventoryDataBean;
    let criteria = new CustomerOnOrderWithAtsInfoBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = inventoryDataBean.fabricStyleCode;
    criteria.colorCode = inventoryDataBean.fabricStyleColorCode;
    criteria.fetchQuantityAvailableLinesOnly = true;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new SkuBatchInventorySummaryDetailsPrintRequest();
    listRequest.criteria = criteria;
    listRequest.input = reportBean;
    ReportService.getSkuBatchInventorySummaryDetailsPrintReport(
      listRequest,
      this.generateOnHandQtySummaryResponse,
      this.errorCallBack
    );
  };
  generateOnHandQtySummaryResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  vendorOnOrderQtyClick = (e, code, rowData) => {
    if (e.detail === 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Fetching VendorOnOrder details ...",
      });
      let vendorList = [];
      let vendorDataList = new CustomerOnOrderWithAtsInfoBean();
      vendorDataList.fabricStyleCode = rowData.fabricStyleCode;
      vendorDataList.fabricStyleName = rowData.fabricStyleName;
      vendorDataList.fabricStyleColorCode = rowData.fabricStyleColorCode;
      vendorDataList.vendorInfo = rowData.vendorInfo;
      if (!isEmptyArray(rowData.vendorInfo)) {
        vendorList = rowData.vendorInfo;
        this.setState({
          vendorDataList: vendorDataList,
          vendorList: vendorList,
          isShowVendorQtyPopup: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No data found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowOnHandQtyPopup: isShowPopup,
      isShowVendorQtyPopup: isShowPopup,
    });
  };
  closeAlertSummaryModalCallBack = (isShowPopup) => {
    this.setState({
      isShowOnHandQtySummaryPopup: isShowPopup,
    });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewFabricModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewSalesModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewVendorModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowVendorModule: true,
          moduleForPopup: (
            <PopupVendorModule
              vendorCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPoModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseOrderModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPurchaseReceiptModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseReceiptModule: true,
          moduleForPopup: (
            <PopupPurchaseReceiptModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowCustomerModule: isOpen,
      isShowVendorModule: isOpen,
      isShowPurchaseOrderModule: isOpen,
      isShowSalesModule: isOpen,
      isShowPurchaseReceiptModule: isOpen,
      moduleForPopup: [],
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };


  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item#" : "FabricStyleCode",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item Name" : "FabricStyle Name",
          "fabricStyleName",
          true
        )

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ColorName", "fabricStyleColorName", true)
        .setStyleDetails("left", "8", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "onHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.onHandQuantityClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("AllCustOnOrderQty", "customerOnOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Ats", "availableToSaleQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Customer",
          "customerCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "CustomerName",
          "customerName",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer PO#", "customerPO", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")

    );
    columns.push(
      new ColumnDefinition()
        .setDetails("S.O#", "salesOrder", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewSalesModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("LatestShipDate", "latestShipDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OpenOrderQty", "openOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VndrOnOrderQty", "vendorOnOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.vendorOnOrderQtyClick, null)
    );
    return columns;
  };
  onHandQtyColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails(this.state.is3PL ? "Inventory#" : "RollSKU#", "rollSkuNumber", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Lot Number", "vendorBatchNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Roll Number", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Box", "boxNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPoModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Receipt#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPurchaseReceiptModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty#", "onHandQuantity", true ,true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(" BinLoc#", "aisleInfoText", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  onHandQtySummaryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "CustomerCode#",
          "reserveCustomerCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "CustomerName",
          "reserveCustomerName",
          true
        )
        .setStyleDetails("left", "10", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("No.Of.Rolls", "totalNumberOfRolls", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalYardage", "totalYardage", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  vendorOnOrderColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPoModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(" PO Date", "purchaseOrderDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Vendor#",
          "vendorCode",
          true
        )
        .setStyleDetails("left", "8", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewVendorModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "VendorName",
          "vendorName",
          true
        )
        .setStyleDetails("left", "8", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item#" : "FabricStyle#",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item Name" : "FabricStyle Name",
          "fabricStyleName",
          true
        )
        .setStyleDetails("left", "8", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderQty", "onOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;

  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let vendorList = this.state.vendorList;
    let vendorDataList = this.state.vendorDataList;
    let onHandQtyDataList = this.state.onHandQtyDataList;
    let inventoryDataBean = this.state.inventoryDataBean;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={
            this.state.is3PL
              ? "Customer Item ATS-Inquiry"
              : "Customer Fabric ATS-Inquiry"
          }
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generateExcel={this.generateExcel}
          onModuleExit={this.onModuleExit}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
        />

        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
              enableVritualizer={true}
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowVendorModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPurchaseOrderModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPurchaseReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />

        {/* ------ONHANDQTY POPUP ------*/}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowOnHandQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel1"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"OnHandQty"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateOnHandQtyPdf(e)}
              >
                PDF
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateOnHandQtyExcel(e)}
              >
                Excel
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.onHandQtySummaryOnClick(e)}
              >
                Summary
              </Button>
            </div>
          }
          content={
            <div className="sales_line_pop">
              <Row>
                <Col sm="1">
                  <FormLabel>Company Code</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={inventoryDataBean.companyCode}
                    name={"companyCode"}
                    disabled={true}
                  />
                </Col>

                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={inventoryDataBean.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleColorCode}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>UOM</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={inventoryDataBean.uomCode}
                    name={"uomCode"}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>OnHandQty</FormLabel>
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={inventoryDataBean.totalOnHandQuantity}
                    className="qty_input text-right"
                    decimalScale={2}
                    name={"totalOnHandQuantity"}
                    disabled={true}
                  />
                </Col>
              </Row>

           
                <div className="mt-3">
                  <CustomTable
                    data={onHandQtyDataList}
                    columns={this.onHandQtyColumns()}
                  />
                </div>

             
            </div>
          }
        />

        {/* ------ONHAND QTY SUMMARY POPUP ------*/}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowOnHandQtySummaryPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel2"}
          closeAlertModalCallBack={this.closeAlertSummaryModalCallBack}
          title={"OnHandQuantity Summary Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateOnHandQtySummaryPdf(e)}
              >
                PDF
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateOnHandQtySummaryExcel(e)}
              >
                Excel
              </Button>
            </div>
          }
          content={
            <div className="sales_line_pop">
              <Row>
                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={inventoryDataBean.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleColorCode}
                    disabled={true}
                  />
                </Col>
              </Row>
              <div className="mt-3">
                <CustomTable
                  data={this.state.onHandQtySummaryDataList}
                  columns={this.onHandQtySummaryColumns()}
                />
              </div>
            </div>
          }
        />
        {/* ------VENDOR ONORDER  POPUP ------*/}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowVendorQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"VendorOnOrderDetails"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div>
              <Row>
                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={vendorDataList.fabricStyleCode}
                    disabled={true}
                  />
                </Col>

                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={vendorDataList.fabricStyleName}
                    disabled={true}
                  />
                </Col>

                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    type="text"
                    value={vendorDataList.fabricStyleColorCode}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  {" "}
                  <div className="mt-3">
                    <CustomTable
                      data={vendorList}
                      columns={this.vendorOnOrderColumns()}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          }
        />
      </div>
    );
  }
}
class CriteriaView extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.fabricCodeRef = React.createRef();
    this.colorCodeRef = React.createRef();
    this.state = {
      criteria: this.props.criteria,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setFocus();
  }
  setFocus() {
    if (this.fabricCodeRef.current != null) {
      this.fabricCodeRef.current.focus();
    }
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.props.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  fabricCodeOnChange = (e) => {
    this.props.fabricCodeOnChange(e);
  };
  onFabricColourCodeChange = (e) => {
    this.props.onFabricColourCodeChange(e);
  };
  fabricEnterKeyEventHandler = (e) => {
    this.props.fabricEnterKeyEventHandler(e);
  };
  displayAutoCompleteFabricList = () => {
    this.props.displayAutoCompleteFabricList();
  };
  fabricColourEnterKeyEventHandler = (e) => {
    this.props.fabricColourEnterKeyEventHandler(e);
  };
  displayAutoCompleteFabricColorList = () => {
    this.props.displayAutoCompleteFabricColorList();
  };
  render() {
    let criteria = this.props.criteria;
    return (
      <div>
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            {" "}
            {this.props.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.fabricCodeOnChange}
              ref={this.fabricCodeRef}
              name="fabricStyleCode"
              placeholder="Item"
              value={criteria.fabricStyleCode}
              lookupRequired={true}
              lookupHandler={this.state.fabricLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.fabricEnterKeyEventHandler}
              autoCompleteListData={ this.props.fabricPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteFabricList}
              showAutoCompleteList={this.props.showAutoCompleteFabricList}
              disabled={this.props.isDisableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onChange}
              name="fabricStyleName"
              placeholder="Item"
              value={criteria.fabricStyleName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>ColorCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onFabricColourCodeChange}
              ref={this.colorCodeRef}
              name="fabricStyleColorCode"
              placeholder="Color"
              value={criteria.fabricStyleColorCode}
              lookupRequired={this.props.isShowColorLookup}
              lookupHandler={this.props.colorLookupHandler}
              enterKeyEventHandler={this.fabricColourEnterKeyEventHandler}
              autoCompleteListData={this.props.fabricColourPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteFabricColorList}
              showAutoCompleteList={this.props.showAutoCompleteFabricColorList}
              disabled={this.props.isDisableFields}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
function CustomerFabricsATSInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <CustomerFabricsATS {...props} name="" /> <br />
    </div>
  );
}

export default CustomerFabricsATSInquiry;
